import React from "react";
import Modal from "../modal";
import Button from "../../button";
import "./styles.css";

// Модалка подтверждения «Да/Нет» (удаление и другие необратимые действия).
export default function ModalYesNo({ isOpenModal, closeModal, actionBtnYes, actionBtnNo, title }) {
    return <Modal isOpenModal={isOpenModal} closeModal={closeModal} title={title}>
        <div className="modal-yes-no__buttons">
            <Button className="btn-danger" onClick={actionBtnYes}>Да</Button>
            <Button onClick={actionBtnNo ?? closeModal}>Нет</Button>
        </div>
    </Modal>;
}
